import React, { useState, useEffect } from 'react';

const PaymentModal = ({ isOpen, onClose, data }) => {
	const [amount, setAmount] = useState(0);
	const [paymentType, setPaymentType] = useState('Visa');
	const [isAmountEmpty, setIsAmountEmpty] = useState(false);
	const [email, setEmail] = useState('');

	useEffect(() => {
		if (data?.totalDue) {
			setAmount(parseFloat(data.totalDue));
		}
		if (data?.emailAddress) {
			setEmail(parseFloat(data.emailAddress));
		}
	}, [data]);

	const handleAmountChange = (e) => {
		setAmount(e.target.value);
		setIsAmountEmpty(false);
	};
	const handleEmailChange = (e) => {
		setEmail(e.target.value);
	};

	const handlePaymentTypeChange = (e) => {
		setPaymentType(e.target.value);
	};

	const handleSubmit = () => {
		if (amount === undefined || amount == NaN || amount === '') {
			setIsAmountEmpty(true);
			return;
		}
		if (paymentType === 'Visa') {
			document.forms[0].submit();
		} else if (paymentType === 'Amex') {
			document.forms[1].submit();
		} else {
			alert('Select payment mode to proceed!');
		}
		onClose();
	};

	return (
		<div className={`fixed inset-2 ${isOpen ? '' : 'hidden'} `}>
			<div className='flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
				<div className='fixed inset-0 transition-opacity'>
					<div className='absolute inset-0 bg-gray-500 opacity-75'></div>
				</div>

				<span
					className='hidden sm:inline-block sm:align-middle sm:h-screen'
					aria-hidden='true'>
					&#8203;
				</span>

				<div
					className='inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'
					role='dialog'
					aria-modal='true'
					aria-labelledby='modal-headline'>
					<div className='bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4'>
						<div className='mt-3 sm:mt-0 sm:ml-4 text-center sm:text-left'>
							<h3
								className='text-lg leading-6 font-medium text-gray-900 mb-4'
								id='modal-headline'>
								Payment Information
							</h3>
							<div className='mt-2'>
								<div className='mt-4 mb-4'>
									<label
										htmlFor='amount'
										className='block text-sm font-medium text-gray-700'>
										Amount:
									</label>
									<input
										type='number'
										id='amount'
										name='amount'
										value={amount}
										onChange={handleAmountChange}
										className={`mt-1 p-2 border ring-indigo-500 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-500 rounded-md ${
											isAmountEmpty ? 'border-red-500' : ''
										}`}
									/>
									{isAmountEmpty && (
										<p className='text-red-500 mt-1'>Amount is required.</p>
									)}
								</div>
								<div className='mt-4 mb-4'>
									<label
										htmlFor='email'
										className='block text-sm font-medium text-gray-700'>
										Email Address:
									</label>
									<input
										type='email'
										id='email'
										name='email'
										value={email}
										onChange={handleEmailChange}
										className={`mt-1 p-2 border ring-indigo-500 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-500 rounded-md`}
									/>
								</div>
								<div className='mb-4'>
									<label className='block text-sm font-medium text-gray-700 mt-6'>
										Payment Type:
									</label>
									<div className='mt-2'>
										<label className='inline-flex items-center'>
											<input
												type='radio'
												value='Visa'
												checked={paymentType === 'Visa'}
												onChange={handlePaymentTypeChange}
												className='form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out'
											/>
											<span className='ml-2'>Visa / Master</span>
										</label>
										<label className='inline-flex items-center ml-4'>
											<input
												type='radio'
												value='Amex'
												checked={paymentType === 'Amex'}
												onChange={handlePaymentTypeChange}
												className='form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out'
											/>
											<span className='ml-2'>Amex</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					<form
						method='post'
						action='https://ebis.waterboard.lk/Payment/Checkout.php'>
						<input type='hidden' name='account_no' value={data?.accountNo} />
						<input type='hidden' name='order_amount' value={amount} />
						<input type='hidden' name='payment_type' value='1' />
						<input type='hidden' name='payment_source' value='DirectPay' />
						<input type='hidden' name='order_currency' value='LKR' />
						<input type='hidden' name='mobile_no' value={data?.mobileNo} />
						<input type='hidden' name='customer_receipt_email' value={email} />
					</form>

					<form
						method='post'
						action='https://ebis.waterboard.lk/AMEX/ipay-express-checkout/process.php'>
						<input type='hidden' name='account_no' value={data?.accountNo} />
						<input type='hidden' name='order_amount' value={amount} />
						<input type='hidden' name='payment_type' value='1' />
						<input type='hidden' name='payment_source' value='DirectPay' />
						<input type='hidden' name='order_currency' value='LKR' />
						<input type='hidden' name='mobile_no' value={data?.mobileNo} />
						<input type='hidden' name='customer_receipt_email' value={email} />
					</form>

					<div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>
						<button
							type='button'
							onClick={handleSubmit}
							className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm'>
							Proceed
						</button>
						<button
							type='button'
							onClick={onClose}
							className='mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm'>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PaymentModal;
